import { gql } from '@/apollo';

export const UPDATE_WF_CONFIG_MUTATION = gql(`
  mutation updateWorkflowConfigMutation(
    $workflowRowId: BigInt!
    $newInitState: JSON
    $newInitActions: JSON
    $newStateSchema: JSON
    $newActions: JSON
    $newTransitions: JSON
  ) {
    newWorkflowConfig(
      input: {
        config: {
          workflowRowId: $workflowRowId
          initState: $newInitState
          initActions: $newInitActions
          stateSchema: $newStateSchema
          actions: $newActions
          transitions: $newTransitions
        }
      }
    ) {
      workflow {
        rowId
        config {
          rowId
          overview
          initState
          initActions
          stateSchema
          actions
          transitions
        }
      }
    }
  }
`);

export const FAST_WORKFLOW_QUERY = gql(`
  query FastWorkflowQuery(
    $workflowId: BigInt!
    $first: Int
    $cursor: Cursor
    $orderBy: [FastTraceStateOrderBy!]
    $filter: FastTraceStateFilter 
    $archived: Boolean
  ) {
    workflowByRowId(rowId: $workflowId) {
      rowId
      name
      canUpdate
      isReader
      config {
        rowId
        overview
        initState
        initActions
        stateSchema
        actions
        transitions
        archiveCondition
      }
      # If $groupBy is null, all the traces will be available in one group with index 'null'
      fastTraceStates(
        first: $first
        after: $cursor
        filter: $filter
        orderBy: $orderBy
        archived: $archived
      ) {
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          rowId
          data
          meta
          archived
          archivedAt
          manuallyArchived
          trace {
            rowId
          }
        }
      }
      groups {
        nodes {
          rowId
          label
          canAct: canActQuick
          name
          avatar
        }
      }
    }
  }
`);

export const FAST_WORKFLOW_COUNT_QUERY = gql(`
  query FastWorkflowCountQuery(
    $workflowId: BigInt!
    $filter: FastTraceStateFilter 
    $archived: Boolean
  ) {
    workflowCount: workflowByRowId(rowId: $workflowId) {
      rowId
      fastTraceStatesCount(filter: $filter, archived: $archived)
    }
  }
`);
